import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-9" }
const _hoisted_2 = { class: "mb-0" }
const _hoisted_3 = { class: "d-flex" }

import getVehicleResponse from '@/types/responses/getVehicle';
import SelectCameraCheckBox from "@/components/CvrConvert/SelectCameraCheckBox.vue";
import i18n from '@/lang/i18n';
import { computed } from "vue";
import ValidationErrors from "@/components/Common/ValidationErrors.vue";
import {
  CVR_UPLOAD_REQUEST_SELECTABLE_CAMERA,
  CVR_UPLOAD_REQUEST_CHECK_INI_FILE_CAMERA_COLUMN,
  CVR_UPLOAD_REQUEST_ACTIVE_CAMERA_STATUS,
  CVR_UPLOAD_REQUEST_INACTIVE_CAMERA_STATUS,
  CAMERA_ON_KEY
} from "@/services/consts";


export default /*@__PURE__*/_defineComponent({
  __name: 'RequestCameraType',
  props: {
    modelValue: {},
    reading: { type: Boolean },
    vehicle: {},
    errors: {}
  },
  emits: ["update:modelValue", "changeStatusRequestButton"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit
const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

const defaultSelectedValue: string[] = [CVR_UPLOAD_REQUEST_SELECTABLE_CAMERA[CAMERA_ON_KEY]]

const errorMessages = computed(() => {
  let errors = []
  if (props.errors) return props.errors
  if (props.vehicle && !selectableCamera.value.length) errors.push(i18n.global.t('pages.cvr_uploads.requestPanel.emptyCameraSettings'))
  return errors
})

const SELECTABLE_CAMERA_LABELS = {
  "F": i18n.global.t('pages.cvr_uploads.cameraName.front'),
  "R": i18n.global.t('pages.cvr_uploads.cameraName.rear'),
  "I": i18n.global.t('pages.cvr_uploads.cameraName.in'),
  "S": i18n.global.t('pages.cvr_uploads.cameraName.side'),
}

const selectableCamera = computed(() => {
  if (!props.vehicle || props.reading) return []
  let selectable: string[] = []
  const parameters = JSON.parse(JSON.stringify(props.vehicle?.parameters))
  const common = parameters.common
  if (common[CAMERA_ON_KEY] == CVR_UPLOAD_REQUEST_INACTIVE_CAMERA_STATUS) {
    emit('update:modelValue', selectable)
    emit('changeStatusRequestButton', true)
    return selectable
  }

  selectable.push(CVR_UPLOAD_REQUEST_SELECTABLE_CAMERA[CAMERA_ON_KEY])
  const record = parameters.record
  Object.keys(record).forEach((key: string) => {
    if (CVR_UPLOAD_REQUEST_CHECK_INI_FILE_CAMERA_COLUMN.includes(key) && record[key] == CVR_UPLOAD_REQUEST_ACTIVE_CAMERA_STATUS) {
      selectable.push(CVR_UPLOAD_REQUEST_SELECTABLE_CAMERA[key])
    }
  })
  emit('update:modelValue', defaultSelectedValue)
  emit('changeStatusRequestButton', false)
  return selectable
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(i18n).global.t('pages.cvr_uploads.requestCameraType')), 1),
    _createVNode(ValidationErrors, { messages: errorMessages.value }, null, 8, ["messages"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(SelectCameraCheckBox, {
        modelValue: modelValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
        items: SELECTABLE_CAMERA_LABELS,
        selectableItems: selectableCamera.value,
        disabled: !props.vehicle
      }, null, 8, ["modelValue", "selectableItems", "disabled"])
    ])
  ]))
}
}

})